import { render, staticRenderFns } from "./SeparateClient.vue?vue&type=template&id=61b386fe&"
import script from "./SeparateClient.vue?vue&type=script&lang=js&"
export * from "./SeparateClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports